let specifications = [

  {
    id: "6584171692126",
       addtoCart: true,
    aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005002116239574.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
      {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005002116239574.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      }
    ],
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/fer-a-lisser-kipozi-v5-lisseur-et-fer-a-friser-2/f-110570501-kip0192802898265.html'
      }
    ],
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-2-In-1-Hair-Straightener-Curling-Iron-Titanium-Plate-Instant-Heat-Auto-Shut-Off-Purple/878105466'
      },
    ],
  },

 {
    id: "6584171790430",
   addtoCart: true,
    aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005002115518946.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
 {
      	country: '俄罗斯',
      	link: 'https://www.aliexpress.com/item/1005002115518946.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
 {
      	country: '波兰',
      	link: 'https://www.aliexpress.com/item/1005002115518946.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
      {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005002115518946.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      }
    ],
  Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-pro-lisseur-cheveux-lisseur-et-fer-a-frise/f-110570501-kip0192802929044.html?idOffre=644830428#mpos=0|mp'
      }
    ],
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Professional-Hair-Straightener-2-in-1-Curling-Iron-Hair-Titanium-Pro-Flat-Iron-Fast-Heat-Styling-Tool-with-LED-Digital-Display-V7-Rose-Gold/926803112'
      },
    ],
  },


{
    id: "6584172118110",
  addtoCart: true,
      aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005002101047594.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
 {
      	country: '俄罗斯',
      	link: 'https://www.aliexpress.com/item/1005002101047594.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
 {
      	country: '波兰',
      	link: 'https://www.aliexpress.com/item/1005002101047594.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
      {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005002101047594.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      }
    ],
 ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/383937939660'
      }
    ],
Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/mini-lisseur-cheveux-fer-a-lisser-de-voyage-peti/f-110570501-kip0192802950208.html'
      },
    ],
  },

 {
    id: "6584172281950",
   addtoCart: true,
    aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005002116239574.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      },
      {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005002116239574.html?spm=5261.13614343.0.0.69df4dceNz1mzT'
      }
    ],
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/lisseur-cheveux-professionnel-titane-230-kipoz/f-110570501-kip0603658762100.html?idOffre=284491664'
      },
    ],
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-2-In-1-Hair-Straightener-Curling-Iron-Titanium-Plate-Instant-Heat-Auto-Shut-Off-Purple/878105466'
      }
    ],
ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/233332711576'
      },
    ],
  },


 {
    id: "6584172216414",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-1-Inch-Ceramic-Plates-Flat-Iron-Hair-Straightener-Adjustable-Dual-Voltage-Travel/677508159'
      },
    ],
  },

 {
    id: "6584172445790",
   addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/lisseur-pour-cheveux-epais-lisseur-cheveux-profe/f-110570501-kip0192802861795.html'
      },
    ],
ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/373321125724'
      },
    ],
 walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Wide-Plate-Hair-Straightener-Flat-Iron-Professional-Dual-Voltage-Digital-Auto-Off-Purple/680166704'
      },
    ],
  },

{
    id: "6584172576862",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-1-Inch-Titanium-Flat-Iron-Pink-Anti-frizz-Instant-Heat-Digital-Display-Hair-Straightener/661719237'
      },
    ],
  },

{
    id: "6584172675166",
   addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/lisseur-cheveux-kipozi-lisseur-professionnel-fer/f-110570501-auc0192802872586.html'
      },
    ],
  ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/283049965772'
      },
    ],
    aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005002099898643.html?spm=5261.13614343.0.0.551e4dceNqVStu'
      },
  {
      	country: '俄罗斯',
      	link: 'https://www.aliexpress.com/item/1005002099898643.html?spm=5261.13614343.0.0.551e4dceNqVStu'
      },
  {
      	country: '波兰',
      	link: 'https://www.aliexpress.com/item/1005002099898643.html?spm=5261.13614343.0.0.551e4dceNqVStu'
      },
  {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005002099898643.html?spm=5261.13614343.0.0.551e4dceNqVStu'
      },
    ],
  },

{
    id: "6584172773470",
   addtoCart: true,
aliExpress: [
      {
      	country: '西班牙',
      	link: 'https://www.aliexpress.com/item/1005001319359204.html?spm=5261.13614343.0.0.37604dceaW1zOz'
      },
 {
      	country: '俄罗斯',
      	link: 'https://www.aliexpress.com/item/1005001319359204.html?spm=5261.13614343.0.0.37604dceaW1zOz'
      },
 {
      	country: '波兰',
      	link: 'https://www.aliexpress.com/item/1005001319359204.html?spm=5261.13614343.0.0.37604dceaW1zOz'
      },
 {
      	country: '法国',
      	link: 'https://www.aliexpress.com/item/1005001319359204.html?spm=5261.13614343.0.0.37604dceaW1zOz'
      },
    ],
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-professional-titanium-flat-iron-hair-straig/f-110570501-kip0603658762049.html?idOffre=284502828'
      },
    ],
 walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Titanium-Flat-Iron-Hair-Straightener-Wide-Plate-Curling-Iron-Black-Digital-Display-450/805805056'
      },
    ],
ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/283049921545'
      },
    ],
  },

{
    id: "6585499779166",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-lisseur-cheveux-professionnel-lisseur-et-bi/f-110570506-kip0192802911650.html'
      },
    ],
  },

{
    id: "6584171855966",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-1-2-Inch-Curling-Iron-Adjustable-Temperature-Hair-Curler-Anti-scalding-Insulated-Tip-Dual-Voltage-Professional-Spiral-Gift/492522437'
      },
    ],
  },

{
    id: "6584173068382",
  
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Hair-Dryer-Brush-Styler-Hot-Air-Brush-4-in-1-One-Step-Hair-Dryer-Volumizer-Ceramic-Coating-with-Cleaning-Claw/121175093'
      },
    ],
  },

{
    id: "6585462227038",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Titanium-Flat-Iron-2-in-1-Hair-Straightener-and-Curling-Iron-450-Adjustable/777781665'
      },
    ],
  },

{
    id: "6585500532830",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-Small-Flat-Iron-9-10-Inch-for-Short-Hair-Travel-Size-Ceramic-Hair-Straightener-Lightweight-Portable-Black/783879964'
      },
    ],
Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/lisseur-cheveux-ceramique-fer-a-lisser-et-fer-a-bo/f-110570501-kip0192802933683.html'
      },
    ],
  },
{
    id: "6585499320414",
   addtoCart: true,
    walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-1-75-inch-Wide-Plate-Ionic-Flat-Iron-Hair-Straightener-Gray-Titanium-Plate-Adjustable-Temperature/455866304'
      },
    ],
  },

{
    id: "6584172511326",
   addtoCart: true,
    ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/383662594559'
      },
    ],
  },

{
    id: "6584171626590",
   addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/fer-a-friser-kipozi-5-en-1-fer-a-friser-professio/f-110570506-kip0192802919861.html'
      },
    ],
 walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/Kipozi-Professional-Curling-Iron-5-in-1-Hair-Tools-Set-Instant-Heating-With-4-Interchangeable-Ceramic-Barrels-and-1-Curling-Iron-Brush/341952192'
      },
    ],
  },

{
    id: "6584171724894",
  addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-fer-a-friser-fer-a-boucler-9mm-en-ceramiqu/f-110570506-kip0192802929112.html?idOffre=644852548#mpos=0|mp'
      },
    ],
  },

{
    id: "6584172380254",
  addtoCart: true,
     walmart: [
      {
      	country: '美国',
      	link: 'https://www.walmart.com/ip/KIPOZI-1-inch-Ceramic-Curling-Iron-Hair-Curler-Instant-Heat-170-450-Include-Heat-Resistant-Glove/666934596'
      },
    ],
  },

{
    id: "6584170610782",
   addtoCart: true,
     walmart: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/seche-cheveux-professionnel-kipozi-seche-cheveux/f-110570504-kip0192802858825.html?idOffre=1138422964'
      },
    ],
  },

{
    id: "6584172839006",
  addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/seche-cheveux-professionnel-kipozi-2200w-puissant/f-110570504-kip0192802896711.html?idOffre=982924240'
      },
    ],
  },

{
    id: "6585547030622",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/boucleur-wavy-fer-a-boucler-19mm-en-ceramique-bou/f-110570506-kip0192802920003.html?idOffre=730620608#mpos=0|mp'
      },
    ],
  },

{
    id: "6585495421022",
  addtoCart: true,
    ebay: [
      {
      	country: '美国',
      	link: 'https://www.ebay.com/itm/224104066055'
      },
    ],
  },

{
    id: "6585500893278",
  addtoCart: true,
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-mini-lisseur-cheveux-ceramique-fer-a-lisser/f-110570501-kip0192802935786.html?idOffre=538120944'
      },
    ],
  },

{
    id: "6584173166686",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/electromenager/soin-de-la-personne-beaute/kipozi-3-barils-fer-a-boucler-fer-a-onduler-profe/f-110570506-kip0192802898258.html'
      },
    ],
  },

{
    id: "6584171364446",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-23-couleurs-8ml-vernis-manucure-nail-art-lo/f-12702020501-kip0192802898197.html'
      },
    ],
  },

{
    id: "6584170709086",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-lot-6-couleurs-8ml-de-vernis-a-ongles-autom/f-12702020501-kip0192802898173.html'
      },
    ],
  },

{
    id: "6584170676318",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-lot-6-couleurs-8ml-de-vernis-a-ongles-uv-le/f-12702020501-kip0192802914750.html'
      },
    ],
  },

{
    id: "6584171200606",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-lot-de-top-coat-base-coat-semi-permanent-uv/f-12702020501-kip0192802898142.html'
      },
    ],
  },

{
    id: "6584170774622",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-lot-6-couleurs-8ml-de-vernis-a-ongles-uv-le/f-12702020501-auc0192802914583.html'
      },
    ],
  },

{
    id: "6584171036766",
    Cdiscount: [
      {
      	country: '法国',
      	link: 'https://www.cdiscount.com/au-quotidien/hygiene-soin-beaute/kipozi-23-couleurs-8ml-vernis-manucure-nail-art-lo/f-12702020501-kip0192802902405.html'
      },
    ],
  },
      {
    id: "6585500926046",
    addtoCart: true,
  },
      {
    id: "6584171495518",
    addtoCart: true,
  },     
      {
    id: "6585555026014",
    addtoCart: true,
  },
      {
    id: "6585551781982",
    addtoCart: true,
  },
      {
    id: "6584173101150",
    addtoCart: true,
  },
      {
    id: "6584172904542",
    addtoCart: true,
  },
      {
    id: "6585501778014",
    addtoCart: true,
  },
      {
    id: "6585554468958",
    addtoCart: true,
  },
      {
    id: "6585555157086",
    addtoCart: true,
  },
       {
    id: "6584172970078",
    addtoCart: true,
  },
      {
    id: "6584171528286",
    addtoCart: true,
  },
      {
    id: "6602304061534",
    addtoCart: true,
  },
      {
    id: "6607908569182",
    addtoCart: true,
  },
       {
    id: "6607909814366",
    addtoCart: true,
  },
        {
    id: "6584171429982",
    addtoCart: true,
  },
       {
    id: "6584173199454",
    addtoCart: true,
  },
       {
    id: "6585547030622",
    addtoCart: true,
  },
]